export default {
	url_api(state) {
		return state.url_api;
	},
	url_web(state) {
		return state.url_web;
	},
};
